export { CorporativoOnboardingWelcomeTelco } from "./CorporativoOnboardingWelcomeTelco";
